<template>
  <div class="dropdown-selection w-160px mr-5">
    <div class="dropdown-selection-head" @click="isShow = !isShow">
      <button class="btn justify-start" style="width: 100%;" @blur="closeMenu">
        <span>篩選分類/子分類</span>
        <span class="ml-auto">
          <span v-if="isShow" key="arrow_drop_up">
            <v-icon>arrow_drop_up</v-icon>
          </span>
          <span v-if="!isShow" key="arrow_drop_down">
            <v-icon>arrow_drop_down</v-icon>
          </span>
        </span>
      </button>
    </div>
    <div class="dropdown-selection-body block w-260px" v-if="isShow">
      <!-- search -->
      <div class="pa-10px form-item">
        <div class="form-input-group">
          <div class="prepend-icon"><v-icon>search</v-icon></div>
          <input type="text" class="pl-42px" />
        </div>
      </div>
      <!-- categories -->
      <div style="max-height: 412px; overflow-y: scroll;">
        <!-- category -->
        <div v-for="cat in categories" :key="cat.id">
          <div class="pl-10px h-48px d-flex align-center selection-item-hover">
            <v-checkbox v-model="selectedCategories" :value="cat" class="w-100">
              <template v-slot:label>
                <div
                  class="h5 ink-01-emphasis--text h-48px d-flex align-center flex-grow-1"
                >
                  {{ cat.name }}
                </div>
              </template>
            </v-checkbox>
          </div>
          <!-- subcategory -->
          <div
            class="pl-35px h-48px d-flex align-center selection-item-hover"
            v-for="subCat in cat.subcategories"
            :key="subCat.id"
          >
            <v-checkbox
              v-model="selectedSubCategories"
              :value="subCat"
              class="w-100"
            >
              <template v-slot:label>
                <div
                  class="h5 ink-01-emphasis--text h-48px d-flex align-center flex-grow-1"
                >
                  {{ subCat.name }}
                </div>
              </template>
            </v-checkbox>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';

export default {
  props: {
    selectedCategoriesFromParent: {
      type: Array,
      default: () => [],
    },
    selectedSubCategoriesFromParent: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({
    selectedCategories: [],
    selectedSubCategories: [],
    isShow: false,
    categories: null,
  }),
  computed: {
    ...mapState(['currentBuTabId']),
  },
  async created() {
    this.categories = await this.getCategoriesAndSubcategoy('');
  },
  watch: {
    // props from parent
    selectedCategoriesFromParent() {
      this.selectedCategories = this.selectedCategoriesFromParent;
    },
    selectedSubCategoriesFromParent() {
      this.selectedSubCategories = this.selectedSubCategoriesFromParent;
    },
    // value in child
    selectedCategories(categories) {
      categories.forEach((category) => {
        category.subcategories.forEach(
          (subcategory) => {
            const exists = this.selectedSubCategories.find((o) => o.id === subcategory.id);
            if (!exists) {
              this.selectedSubCategories.push(subcategory);
            }
          },
        );
      });

      // Update parent's prop value
      this.$emit(
        'update:selectedCategoriesFromParent',
        this.selectedCategories,
      );
    },
    selectedSubCategories() {
      // Update parent's prop value
      this.$emit(
        'update:selectedSubCategoriesFromParent',
        this.selectedSubCategories,
      );
    },
    async currentBuTabId(newValue) {
      this.categories = await this.getCategoriesAndSubcategoy(newValue);
    },
  },
  methods: {
    ...mapActions('category', ['getCategoriesAndSubcategoy']),
    closeMenu() {
      setTimeout(() => {
        this.isShow = false;
      }, 300);
    },
  },
};
</script>

<style></style>
